import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const createVideoCardAsync = createAsyncThunk(
  "admin/createVideoCard",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/createVideoCard`, payload, toolkit);
  },
);

export const getVideoCardByIdAsync = createAsyncThunk(
  "admin/getVideoCard",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/getVideoCard/${payload.id}`, [], toolkit);
  },
);

export const updateVideoCardAsync = createAsyncThunk(
  "admin/updateVideoCard",
  async (payload, toolkit) => {
    return await AxiosClient("PUT", `/updateVideoCard`, payload, toolkit);
  },
);

export const updateStoreInventoryAsync = createAsyncThunk(
  "admin/updateStoreInventory",
  async (payload, toolkit) => {
    return await AxiosClient("PUT", `/increaseInventory`, payload, toolkit);
  },
);

export const decreaseStoreInventoryAsync = createAsyncThunk(
  "admin/decreaseInventory",
  async (payload, toolkit) => {
    return await AxiosClient("PUT", `/decreaseInventory`, payload, toolkit);
  },
);

export const updateStoreProductStatusAsync = createAsyncThunk(
  "admin/updateStoreProductStatus",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/updateStoreProductStatus`,
      payload,
      toolkit,
    );
  },
);

export const spokenEnglishPackagesAsync = createAsyncThunk(
  "admin/spokenEnglishPackages",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/spokenEnglishPackages?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&search=${payload.search || ""}`,
      [],
      toolkit,
    );
  },
);

export const getAllVideoCardsAsync = createAsyncThunk(
  "admin/getAllVideoCards",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllVideoCards?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&search=${payload.search || ""}&status=${payload.status ?? ""}`,
      [],
      toolkit,
    );
  },
);

export const goalWiseCoursePackagesAsync = createAsyncThunk(
  "admin/goalWiseCoursePackages",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/goalWiseCoursePackages?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&goalId=${payload.goalId || ""}`,
      [],
      toolkit,
    );
  },
);

export const getCoursePackagesAsync = createAsyncThunk(
  "admin/getCoursePackages",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getCoursePackages?batchId=${payload.batchId || ""}`,
      [],
      toolkit,
    );
  },
);

export const deleteVideoCardAsync = createAsyncThunk(
  "admin/deleteVideoCard",
  async (payload, toolkit) => {
    return await AxiosClient(
      "DELETE",
      `/deleteVideoCard/${payload?.id}`,
      [],
      toolkit,
    );
  },
);

export const getAllStoreOrdersAsync = createAsyncThunk(
  "admin/getAllStoreOrders",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllStoreOrders?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }`,
      [],
      toolkit,
    );
  },
);

export const storeOrderDetailsAsync = createAsyncThunk(
  "adminOrderDetails",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `OrderDetails?order_id=${payload?.orderId}`,
      [],
      toolkit,
    );
  },
);

export const updateOrderStatusAsync = createAsyncThunk(
  "admin/updateOrderStatus",
  async (payload, toolkit) => {
    return await AxiosClient("PUT", `/updateOrderStatus`, payload, toolkit);
  },
);
